<template lang="pug">
  .b-progressbar(:class="styling")
    ._legend(v-if="startIcon || startText || finishIcon || finishText")
      span._legend-item(v-if="startIcon || startText" @click="$emit('clickStart')")
        Icon(:name="startIcon" v-if="startIcon")
        | {{ startText }}
      span._legend-item(v-if="finishIcon || finishText" @click="$emit('clickFinish')")
        Icon(:name="finishIcon" v-if="finishIcon")
        | {{ finishText }}
    progress._bar(:value="value" max="100" :class="color")
</template>

<script>
export default {
  name: 'BaseProgressbar',
  props: {
    value: {
      type: Number,
      validator(v) {
        return v >= 0 && v <= 100;
      },
    },
    startText: String,
    startIcon: String,
    finishText: String,
    finishIcon: String,
    styling: String,
    color: String,
  },
};
</script>

<style scoped lang="scss">
.progressbar {
  position: relative;
  cursor: pointer;

  &__legend {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  &__legend-item {
    display: flex;
    align-items: center;
    font-size: 12px;
    text-transform: uppercase;
    color: var(--color-middle-gray);
    svg {
      display: block;
      padding-right: 6px;
      width: 14px;
      height: 14px;
      fill: var(--color-middle-gray);
    }
  }

  &__bar {
    display: block;
    position: relative;
    width: 100%;
    height: 8px;
    background-color: #EBEFF2;
    border-radius: 12px;
    box-shadow: none;
    &::-webkit-progress-bar {
      background-color: #EBEFF2;
      border-radius: 12px;
      box-shadow: none;
    }
    &::-webkit-progress-value {
      background-color: #2ee1ce;
      border-radius: 12px;
      box-shadow: none;
    }
    &::-moz-progress-bar {
      background-color: #2ee1ce;
      border-radius: 12px;
    }
  }

  &.header {
    display: flex;
    flex-direction: column-reverse;
  }
  &.header &__legend-item {
    color: var(--color-white);
    svg {
      fill: var(--color-white);
    }
  }
  &.header &__bar  {
    height: 12px;
    background-color: rgba(#000, 0.21);
    border-radius: 12px;
    margin-bottom: 12px;
    &::-webkit-progress-bar {
      background-color: rgba(#000, 0.21);
    }
    &::-webkit-progress-value {
      background-color: #2ee1ce;
      box-shadow: 0 2px 12px #288ad0;
    }
    &::-moz-progress-bar {
      background-color: #2ee1ce;
    }

    @media (max-width: 1024px) {
      height: 8px;
    }
  }

  &__bar {
    &.green {
      &::-webkit-progress-value { background-color: #5AC169 !important; }
      &::-moz-progress-bar { background-color: #5AC169 !important; }
    }
    &.grey {
      &::-webkit-progress-value { background-color: #cdcdcd !important; }
      &::-moz-progress-bar { background-color: #cdcdcd !important; }
    }
    &.yellow {
      &::-webkit-progress-value { background-color: #F9D208 !important; }
      &::-moz-progress-bar { background-color: #F9D208 !important; }
    }
    &.orange {
      &::-webkit-progress-value { background-color: #FF8D4C !important; }
      &::-moz-progress-bar { background-color: #FF8D4C !important; }
    }
    &.red {
      &::-webkit-progress-value { background-color: #EA4335 !important; }
      &::-moz-progress-bar { background-color: #EA4335 !important; }
    }
  }
}
</style>
